import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';

/**
 * Prevents click if selection has been started
 *
 * @example ```html
 * <div (click.no-selection)="handleClick($event)">Some selectable content</div>
 * ```
 */
@Directive({
  // tslint:disable-next-line: directive-selector
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[click.no-selection]'
})
export class ClickNoSelectionDirective implements OnInit, OnDestroy {
  private subscription: () => void;
  @Output('click.no-selection') public clickNoSelection = new EventEmitter();

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit() {
    this.subscription = this.renderer.listen(this.element.nativeElement, 'click', event => {
      const selection = window.getSelection();

      if (selection.type !== 'Range' || selection.toString().length === 0) {
        this.clickNoSelection.emit(event);
      }
    });
  }

  ngOnDestroy() {
    this.subscription();
  }
}
